// extracted by mini-css-extract-plugin
export default {"photo":"Photo_photo__U12by","treeBlock":"Photo_treeBlock__v+mNj"};